
export const API_BASE_URL = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? "http://192.168.1.4:8080/teleterapia" : "https://teleterapia.pl/api/teleterapia";